namespace uh.scene {

    export class ScreenMain extends Phaser.Scene {

        inputController: uh.input.InputController;

        ui:ui.UI;

        private createAnims(): void {
            this.anims.create({
                key: "car_hit_playing",
                frames: this.anims.generateFrameNames("texture-atlas", {
                    start: 0, end: 21, zeroPad: 4,
                    prefix: "car_hit", suffix: ''
                }),
                frameRate: 24,
                repeat: 0
            });
            this.anims.create({
                key: "car_powerup_playing",
                frames: this.anims.generateFrameNames("texture-atlas", {
                    start: 0, end: 8, zeroPad: 4,
                    prefix: "car_powerup", suffix: ''
                }),
                frameRate: 15,
                repeat: 0
            });
        }

        private readonly obstaclesBlocks:object = {
            2: [0,2],
            5: [2,4],
            7: [1,3],
            9: [0,1,2],
            10: [2,3,4],
            11: [0,1,4],
            12: [0,3,4]
        };
        private readonly totalCarLines:number = 5;
        private readonly carLineWidth:number = 182*uh.App.ART_SCALE;
        private readonly maxDefCarSpeed:number = 38*uh.App.ART_SCALE;
        private readonly carSpeedImpulseByPowerUp:number = 1.07;
        private readonly carAccelerationFactor:number = 150;

        private readonly baseBGImageWidth:number = 960*uh.App.ART_SCALE;
        private readonly baseBGImageHeight:number = 1920*uh.App.ART_SCALE;
        private bgContainer:Phaser.GameObjects.Container;
        private car:Phaser.GameObjects.Sprite;
        private carLineIndex:number = 2;

        private maxCarSpeed:number = this.maxDefCarSpeed;
        private carSpeed:number = 0;
        private scaleFactor:number = 1;
        private scaleFactorCorrectedBySpeed:number = undefined;
        private targetScaleFactorCorrectedBySpeed:number = 1;

        private obstacles:Array<Phaser.GameObjects.Sprite> = [];
        private powerups:Array<Phaser.GameObjects.Image> = [];

        private score:number;
        private distance:number;
        private powerUpsCollected:number;

        private isIngameShown:boolean = false;
        private ingameContainer:Phaser.GameObjects.Container;

        public create(): void {
            this.calculateScaleFactor();

            this.inputController = new uh.input.InputController(this);

            this.createAnims();

            this.ui = new ui.UI(this);
            this.children.add(this.ui);
            this.ui.setDepth(5);

            this.showTitleScreen();

            this.resizeUI();

            window["screenMain"] = this;
        }

        public showTitleScreen():void {
            this.ui.showTitleScreen();
            this.input.once('pointerdown', ()=>{
                this.ui.hideTitleScreen();
                this.showIngameScreen();
                this.createIngameObjects();

                uh.sound.SoundManager.getInstance().playSound('click', 1);
                uh.sound.SoundManager.getInstance().playSound('V6_Camaro-2',0.4);
                uh.sound.SoundManager.getInstance().playSound('Sports-Car-Idle',1, true);
                uh.sound.SoundManager.getInstance().playMusic('Action Sport Loop 01', true, 0.2);
            });
        }

        public onTryAgainClicked:()=>void = ()=>{
            this.isIngameShown = false;
            this.ui.hideTimesUp();
            this.showIngameScreen();
            uh.sound.SoundManager.getInstance().playSound('click', 1);
            uh.sound.SoundManager.getInstance().playSound('Sports-Car-Idle',1, true);
            uh.sound.SoundManager.getInstance().playMusic('Action Sport Loop 01', true, 0.2);
        };

        private resetData():void {
            for (let obs of this.obstacles) {
                obs.destroy(true);
            }
            this.obstacles = [];

            for (let pow of this.powerups) {
                this.tweens.killTweensOf(pow);
                pow.destroy(true);
            }
            this.powerups = [];

            this.carLineIndex = 2;

            this.isIngameShown = true;
            this.isCarSwitchingLine = false;

            this.maxCarSpeed = this.maxDefCarSpeed;
            this.carSpeed = 0;

            this.distance = 0;
            this.powerUpsCollected = 0;
            this.score = 0;

            this.ui.setDistance(this.distance);
            this.ui.setPowerUps(this.powerUpsCollected);
            this.calculateScore();

            this.timeLeft = 35;
            this.ui.setTime(this.timeLeft);

            this.ui.setBest(uh.storage.LocalStorageController.instance.getBest());
        }

        public showIngameScreen():void {
            this.resetData();

            this.ui.showIcon321(this.startTimerCountdown);
        }

        private createIngameObjects():void {
            this.ingameContainer = this.add.container(0, 0);
            this.ingameContainer.setDepth(4);

            this.bgContainer = this.add.container(this.scale.width / 2, 0);
            this.bgContainer.setDepth(0);
            this.ingameContainer.add(this.bgContainer);
            this.fillBgContainer();

            this.car = this.add.sprite(0, 0,'texture-atlas', 'car' + '0000');
            this.car.setOrigin(0.5, 0);
            this.car.setDepth(3);
            this.ingameContainer.add(this.car);

            this.resize();
        }

        private fillBgContainer():void {
            let requiredBgsNum:number = Math.ceil(this.game.scale.height / (this.baseBGImageHeight * this.scaleFactorCorrectedBySpeed)) + 1;
            let hasBgsNum:number = this.bgContainer.getAll().length;
            for (let i:number = hasBgsNum; i < requiredBgsNum; i++) {
                this.bgContainer.add(this.add.image(0, i * (this.baseBGImageHeight - 2), 'texture-atlas', 'bg' + '0000').setOrigin(0.5, 0));
            }
        }

        //TIMER
        private timerEvent: Phaser.Time.TimerEvent = null;
        private timeLeft:number = 35;
        private timeAlert:number = 5;
        public startTimerCountdown:()=> void = () => {
            this.restartTimer();
            this.isActivated = true;
        };

        public restartTimer():void {
            this.destroyTimer();

            this.timerEvent = this.time.addEvent({delay: 1000, repeat: -1});
            this.timerEvent.callback = () => {
                this.timeLeft--;
                this.ui.setTime(this.timeLeft);

                if (this.timeLeft == 0) {
                    this.destroyTimer();
                    this.onTimeout();
                } else if (this.timeLeft <= this.timeAlert) {
                    this.ui.animateTimeIconScale(1000, 0, false);
                    uh.sound.SoundManager.getInstance().playSound('countdown_tick', 0.5, false);
                }
            };
        }

        public destroyTimer(): void {
            if (!this.timerEvent) return;
            this.timerEvent.paused = true;
            this.timerEvent.destroy();
            this.timerEvent.callback = null;
        }

        private sendScoreToServer(score:number):void {
            let http = new XMLHttpRequest();
            let url = 'https://aftermarket.ctr.co.kr/api/Game';
            http.open('POST', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            http.onreadystatechange = function() {
                console.log(http.responseText);
                if(http.readyState == 4 && http.status == 200) {
                    console.log(http.responseText);
                }
            }
            http.send(JSON.stringify({"score": score}));
        }

        public onTimeout(): void {
            if (this.score > uh.storage.LocalStorageController.instance.getBest()) {
                let best:number = this.score;
                uh.storage.LocalStorageController.instance.setBest(best);
                this.ui.setBest(best);
                this.sendScoreToServer(best);
            }

            this.isActivated = false;
            this.ui.showTimesUp(this.score, this.distance, this.onTryAgainClicked);

            uh.util.Functions.destroyDelayedCall(this.powerupsSpawner);
            this.powerupsSpawner = null;
            this.isPowerUpSpawnAllowed = true;

            uh.sound.SoundManager.getInstance().stopMusic();
            uh.sound.SoundManager.getInstance().playSound('defeat', 0.5);
        }

        private calculateLineX(lineIndex:number):number {
            return this.scale.width/2 - ((this.totalCarLines / 2 - 0.5) - lineIndex) * this.carLineWidth * this.scaleFactor;
        }

        private isCarSwitchingLine:boolean = false;
        private moveToLine(lineIndex:number):void {
            if (this.carLineIndex == lineIndex) return;

            this.carLineIndex = lineIndex;

            this.tweens.killTweensOf(this.car);

            let newLineX:number = this.calculateLineX(this.carLineIndex);
            this.isCarSwitchingLine = true;
            let duration:number = 375 - this.carSpeed / this.maxCarSpeed * 300;
            this.add.tween({
                targets:this.car,
                x: newLineX,
                duration: duration * 0.9,
                delay: duration * 0.1,
                onComplete: ()=>{
                    this.isCarSwitchingLine = false;
                },
                ease: Phaser.Math.Easing.Sine.Out
            });
            let angle:number = 12 - this.carSpeed / this.maxCarSpeed * 6;
            this.add.tween({
                targets:this.car,
                angle: newLineX > this.car.x ? angle : -angle,
                duration: duration / 2,
                ease: Phaser.Math.Easing.Sine.Out,
                onComplete:()=>{
                    this.add.tween({
                        targets:this.car,
                        angle: 0,
                        duration: duration / 2,
                        ease: Phaser.Math.Easing.Sine.Out
                    });
                }
            });
        }

        private moveToSideCrash(right:boolean):void {
            let toX:number = this.car.x + (right ? 1 : -1) * this.carLineWidth * 0.25 * this.scaleFactor;
            this.isCarSwitchingLine = true;
            let duration:number = (500 - this.carSpeed / this.maxCarSpeed * 250) / 2;
            let angle:number = 4 - this.carSpeed / this.maxCarSpeed * 2;
            this.add.tween({
                targets:this.car,
                x: toX,
                angle: toX > this.car.x ? angle : -angle,
                duration: duration / 2,
                yoyo: true,
                onComplete: ()=>{
                    this.isCarSwitchingLine = false;
                }
            });
        }

        private findClosestLine():void {
            let minDx:number = Number.MAX_VALUE;
            let closestLine:number = -1;
            for (let i:number = 0; i < this.totalCarLines; i++) {
                let _x:number = this.calculateLineX(i);
                let dx = Math.abs(_x - this.car.x);
                if (dx < minDx) {
                    minDx = dx;
                    closestLine = i;
                }
            }
            this.carLineIndex = closestLine;
        }

        private checkMovement(): void {
            // if (this.isCarSwitchingLine) return;

            let newCarLineIndex:number = this.carLineIndex;
            if (this.inputController.keyRightPressedDownAndReleased()) {
                this.inputController.keyRightPressUsed();
                if (this.carLineIndex < this.totalCarLines - 1) {
                    newCarLineIndex = this.carLineIndex + 1;
                }
            } else if (this.inputController.keyLeftPressedDownAndReleased()) {
                this.inputController.keyLeftPressUsed();
                if (this.carLineIndex > 0) {
                    newCarLineIndex = this.carLineIndex - 1;
                }
            }

            if (newCarLineIndex != this.carLineIndex) {
                if (!this.checkObstaclesHit(newCarLineIndex)) {
                    this.moveToLine(newCarLineIndex);
                } else {
                    this.moveToSideCrash(newCarLineIndex > this.carLineIndex);
                }
            }
        }

        private isCrashed:boolean = false;
        private isActivated:boolean = false;
        private ticker: number = 35;

        public calculateScaleFactor():void {
            this.scaleFactor = 1;

            let artRatioHW:number = this.baseBGImageHeight / this.baseBGImageWidth;
            if (this.scale.width * artRatioHW > this.scale.height) {
                this.scaleFactor = this.scale.height/this.baseBGImageHeight;
            } else {
                this.scaleFactor = this.scale.width/this.baseBGImageWidth;
            }

            this.targetScaleFactorCorrectedBySpeed = this.scaleFactor;
            /*if (this.carSpeed > this.maxDefCarSpeed) {
                this.targetScaleFactorCorrectedBySpeed *= this.maxDefCarSpeed / this.carSpeed;
                this.targetScaleFactorCorrectedBySpeed = Math.pow(this.targetScaleFactorCorrectedBySpeed, 0.9);
                if (this.targetScaleFactorCorrectedBySpeed > this.scaleFactor) this.targetScaleFactorCorrectedBySpeed = this.scaleFactor;
            }*/
            if (typeof this.scaleFactorCorrectedBySpeed == "undefined") {
                this.scaleFactorCorrectedBySpeed = this.targetScaleFactorCorrectedBySpeed;
            } else {
                this.scaleFactorCorrectedBySpeed += (this.targetScaleFactorCorrectedBySpeed - this.scaleFactorCorrectedBySpeed) / 10;
            }

        }

        public resize():void {
            let _carScale:number = this.car.frame.name == 'car0000' ? 1 : 2;

            this.bgContainer.setScale(this.scaleFactorCorrectedBySpeed);
            this.car.setScale(_carScale * this.scaleFactorCorrectedBySpeed);
            for (let i:number = this.obstacles.length - 1; i >= 0; i--) {
                this.obstacles[i].setScale(this.scaleFactorCorrectedBySpeed,this.obstacles[i]["-scaleY-"]*this.scaleFactorCorrectedBySpeed);
                this.obstacles[i].x = this.scale.width / 2;
            }
            for (let i:number = this.powerups.length - 1; i >= 0; i--) {
                this.powerups[i].setScale(this.powerups[i].scale * this.scaleFactorCorrectedBySpeed);
                this.powerups[i].x = this.calculateLineX(this.powerups[i]["line"]);
            }

            if (!this.isCarSwitchingLine || !this.isActivated) {
                this.car.x = this.calculateLineX(this.carLineIndex);
            }
            this.car.y = this.scale.height - this.car.height * _carScale * this.scaleFactorCorrectedBySpeed;

            this.bgContainer.x = this.scale.width / 2;
        }

        public updatePowerups():void {
            for (let i:number = this.powerups.length - 1; i >= 0; i--) {
                let powerUp:Phaser.GameObjects.Image = this.powerups[i];
                powerUp.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;

                if (powerUp.y > this.scale.height + powerUp.height * this.scaleFactorCorrectedBySpeed) {
                    this.powerups.splice(i, 1);
                    this.tweens.killTweensOf(powerUp);
                    powerUp.destroy(true);
                }
            }

            this.checkPowerupsCollect(this.carLineIndex);
        }

        public checkPowerupsCollect(carLineIndex:number):void {
            for (let i:number = this.powerups.length - 1; i >= 0; i--) {
                let powerUp:Phaser.GameObjects.Image = this.powerups[i];

                if (powerUp["line"] != carLineIndex) continue;
                if (powerUp.y < this.car.y) continue;
                if (powerUp.y > this.car.y + this.car.height * this.scaleFactorCorrectedBySpeed) continue;

                this.powerups.splice(i, 1);
                powerUp.destroy(true);

                this.onPowerupCollcted(powerUp);
            }
        }

        public onPowerupCollcted(powerUp):void {
            this.car.anims.play('car_powerup_playing')
                .once('animationcomplete', ()=>{this.car.setFrame('car'+'0000')});

            this.maxCarSpeed += this.carSpeedImpulseByPowerUp;
            this.carSpeed = this.maxCarSpeed;

            this.powerUpsCollected++;
            this.ui.setPowerUps(this.powerUpsCollected);
            this.calculateScore();
            this.ui.showBonusSecGained(powerUp.x, powerUp.y, 700, 100);

            let rnd:number = Math.ceil(Math.random()*3);
            uh.sound.SoundManager.getInstance().playSound('ui-star-'+rnd, 0.5);
            uh.util.Functions.delayedCall(550, ()=>{
                uh.sound.SoundManager.getInstance().playSound('star'+rnd, 0.5);
            });

            uh.sound.SoundManager.getInstance().playSound('Corvette4', 0.1);
        }

        public spawnPowerUp(line:number = undefined, startY:number = 0):void {
            if (!this.isPowerUpSpawnAllowed) return;

            this.runPowerUpSpawner();

            let rnd:number = Math.random();
            let powerup:string = rnd < 0.25 ? "pu_logo" : rnd < 0.6 ? "pu_wheel" : "pu_ball";

            if (typeof line == "undefined") {
                line = Math.floor(Math.random()*this.totalCarLines);
            }

            let powerUp:Phaser.GameObjects.Image = this.add.image(this.calculateLineX(line), startY,"texture-atlas", powerup + '0000');
            powerUp.y -= powerUp.height;
            powerUp.setOrigin(0.5, 0.5);
            powerUp["line"] = line;
            powerUp["powerup"] = powerup;
            powerUp.setDepth(2);
            this.powerups.push(powerUp);
            this.ingameContainer.add(powerUp);

            this.tweens.add({
                targets: powerUp,
                scale: 0.92,
                duration: 500,
                yoyo:true,
                repeat: -1
            });
        }

        private powerupsSpawner = null;
        private isPowerUpSpawnAllowed:boolean = true;
        public runPowerUpSpawner():void {
            // this.isPowerUpSpawnAllowed = false;
            // this.powerupsSpawner = uh.util.Functions.delayedCall((0.5 + Math.random()*(1 - 0.5)) * 1000, ()=>{
            //     this.isPowerUpSpawnAllowed = true;
            // });
        }

        public findLinesNotBlockingByObstacle(obstacleID:number):number {
            let acceptableLines = [];
            for (let l:number = 0; l < this.totalCarLines; l++) {
                if (this.obstaclesBlocks[obstacleID].indexOf(l) < 0) {
                    acceptableLines.push(l);
                }
            }
            return acceptableLines.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableLines) : 2;
        }

        public findObstacleNotBlocking(lineIndex:number):number {
            let acceptableObstacles = [];
            for (let obsId in this.obstaclesBlocks) {
                if (this.obstaclesBlocks[obsId].indexOf(lineIndex) < 0) {
                    acceptableObstacles.push(obsId);
                }
            }
            return acceptableObstacles.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableObstacles) : 1;
        }

        public findLineNotBlockedByObstacle(obstacle:number):number {
            let acceptableLines = [];
            for (let line:number = 0; line < this.totalCarLines; line++) {
                if (this.obstaclesBlocks[obstacle].indexOf(line) < 0) {
                    acceptableLines.push(line);
                }
            }
            return acceptableLines.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableLines) : 2;
        }

        private obstacleIDs:number[] = [2,5,7,9,10,11,12];
        private randomizeBarrier():number {
            let id:number = Phaser.Utils.Array.GetRandom(this.obstacleIDs);
            return id;
        }

        public spawnObstacle():void {
            let id:number = this.randomizeBarrier();

            let spawnAtLine:number = -1;
            if (id == 2) {
                spawnAtLine = 1;
            } else if (id == 5) {
                spawnAtLine = 3;
            } else if (id == 7) {
                spawnAtLine = 2;
            }
            if (spawnAtLine == -1) {
                spawnAtLine = this.findLineNotBlockedByObstacle(id);
            }
            this.spawnPowerUp(spawnAtLine);

            let _id:number = id;
            if (id == 5) {
                _id = 2;
            } else if (id == 7) {
                _id = 2;
            } else if (id == 10) {
                _id = 9;
            } else if (id == 12) {
                _id = 11;
            }
            let objectName:string = 'obstacle_' + _id;

            let obs:Phaser.GameObjects.Sprite = this.add.sprite(this.scale.width/2, -400,"texture-atlas", objectName + '0000');
            obs["-scaleY-"] = 1;
            obs["id"] = id;
            obs.setDepth(1);
            this.obstacles.push(obs);
            if (id == 7) {
                obs.setOrigin(0.3, 1);
            } else {
                obs.setOrigin(0.5, 1);
                if (_id != id) {
                    obs.flipX = true;
                }
            }
            this.ingameContainer.addAt(obs, this.ingameContainer.getIndex(this.car));

            let animName:string = objectName + '_idle';
            this.anims.create({
                key: animName,
                frames: this.anims.generateFrameNames("texture-atlas", {
                    start: 0, end: 9, zeroPad: 4,
                    prefix: objectName, suffix: ''
                }),
                frameRate: 24,
                repeat: -1
            });
            obs.anims.play(animName);
        }

        public checkObstaclesHit(carLineIndex:number):boolean {
            for (let i:number = this.obstacles.length - 1; i >= 0; i--) {
                let obs:Phaser.GameObjects.Sprite = this.obstacles[i];

                if (obs.y < this.car.y || obs.y > 0.95 * this.scale.height + obs.height * this.scaleFactorCorrectedBySpeed) continue;

                if (!obs["-alreadyHited-"] && this.obstaclesBlocks[obs["id"]].indexOf(carLineIndex) >= 0) {
                    obs["-alreadyHited-"] = true;

                    this.car.anims.play('car_hit_playing')
                        .once('animationcomplete', ()=>{this.car.setFrame('car'+'0000')});

                    this.isCrashed = true;
                    this.carSpeed *= 0.25;
                    this.maxCarSpeed = this.maxDefCarSpeed;

                    this.add.tween({
                        targets: obs,
                        // "-scaleY-": 0,
                        "alpha": 0,
                        repeat: 4,
                        duration: 175,
                        onComplete: ()=>{
                            let ind:number = this.obstacles.indexOf(obs);
                            if (ind >= 0) this.obstacles.splice(ind, 1);
                            obs.destroy(true);

                            uh.util.Functions.delayedCall(950, ()=>{
                                this.isCrashed = false;
                            });
                        }
                    });

                    let rnd:number = Math.ceil(Math.random()*3);
                    uh.sound.SoundManager.getInstance().playSound('crash-'+rnd, 0.5);

                    this.cameras.main.shake(800, 0.005);

                    return true;
                }
            }

            return false;
        }

        public updateObstacles():void {
            for (let i:number = this.obstacles.length - 1; i >= 0; i--) {
                let obs:Phaser.GameObjects.Image = this.obstacles[i];
                obs.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;

                if (obs.y > this.scale.height + obs.height * this.scaleFactorCorrectedBySpeed) {
                    this.obstacles.splice(i, 1);
                    obs.destroy(true);

                    this.maxCarSpeed += 1;
                }
            }

            this.checkObstaclesHit(this.carLineIndex);
        }

        public updateBG():void {
            this.bgContainer.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;
            if (this.bgContainer.y >= 0) {
                this.bgContainer.y = -this.baseBGImageHeight * this.scaleFactorCorrectedBySpeed;
            }
        }

        public resizeUI():void {
            this.ui.resize(this.scaleFactor, (this.scale.width - this.baseBGImageWidth * this.scaleFactor) / 2, this.carLineWidth * this.scaleFactor / this.scale.width);
        }

        private calculateScore():void {
            this.score = Math.floor(this.distance / 0.01) + this.powerUpsCollected * 100;
            this.ui.setScore(this.score);
        }

        public update(): void {
            this.calculateScaleFactor();

            this.resizeUI();

            if (this.isIngameShown) {
                this.resize();
                this.fillBgContainer();
            }

            if (!this.isActivated) return;

            // if (!this.isCrashed) {
                this.ticker++;

                let carAccelerationFactor = this.carSpeed < this.maxCarSpeed * 0.5 ? this.carAccelerationFactor * 0.1 : this.carAccelerationFactor;
                this.carSpeed += (this.maxCarSpeed  - this.carSpeed) / carAccelerationFactor;

                if (this.carSpeed > this.maxCarSpeed) {
                    this.carSpeed = this.maxCarSpeed;
                }

                this.distance += this.carSpeed / 10000;
                this.distance = Math.ceil(this.distance * 100) / 100;
                this.ui.setDistance(this.distance);
                this.calculateScore();

                if (this.ticker >= 70 - (this.carSpeed / this.maxCarSpeed * 25) /*Math.ceil(this.targetScaleFactorCorrectedBySpeed * 90)*/) {
                    if (Math.random() > 0.1 + 0.2 * this.targetScaleFactorCorrectedBySpeed) {
                        this.spawnObstacle();
                    } else {
                        this.spawnPowerUp(Math.floor(Math.random()*this.totalCarLines));
                    }
                    this.ticker = 0;
                }

                this.checkMovement();

                this.updateBG();
                this.updateObstacles();
                this.updatePowerups();
            // }
        }
    }
}